import React from 'react'
import styles from './home.module.scss'
import UBFLogoBlue from '../../assets/ubf-logo-blue.png'
import { useNavigate } from 'react-router'
import { routes } from '../../utils/routes'
import { FaFacebook, FaYoutube } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"
import { FaTwitter } from "react-icons/fa"
import ImageSlider from '../../components/ImageSlider'
import { Link } from 'react-router-dom'

const HomePage = () => {
    const navigate = useNavigate()
    return (
        <div className={styles._}>
            <div className={styles.container}>
                <div className={styles.top_nav}>
                    <div className={styles.logo_img}>
                        <img src={UBFLogoBlue} alt="ubf logo" />
                    </div>
                    <div className={styles.btn_ctn}>
                        <button onClick={() => navigate(routes.REGISTER)}>Register For Conference</button>
                    </div>
                </div>
                <div className={styles.main_hero}>
                    <div className={styles.content}>
                        <p>Hey there! 👋</p>
                        <h1>Welcome To Our Church</h1>
                        <div className={styles.mobile_image_slider}>
                            <ImageSlider />
                        </div>
                        <p>Glad to have you here. We're University Bible Fellowship (UBF) Nigeria. We are an international evangelical church (non-denominational) dedicated to Christ and his kingdom. <br/> <br /> Our main focus is to study the Bible, grow in the grace and knowledge of our Lord and Savior Jesus Christ, and live according to his teachings as his disciples.  You can join our <a target={"_blank"} href="https://t.me/+77IEYcBpqbZkYTM0">telegram channel</a> to get our audio messages</p>
                        <br />
                        <p>We're having our easter conference coming up soon on the 29th - 31st of March 2024, <Link to={routes.REGISTER}>Register here</Link> to be a part of the expereince</p>
                    </div>
                    <div className={styles.desktop_image_slider}>
                        <ImageSlider />
                    </div>
                </div>
                <div className={styles.social_media_links}>
                    <div className={styles.social_media_link}>
                        <a href="https://web.facebook.com/UBFUnilag?_rdc=1&_rdr"><FaFacebook className={styles.social_icon} /></a> 
                    </div>
                    <div className={styles.social_media_link}>
                        <a href="https://twitter.com/NigeriaUbf"><FaTwitter className={styles.social_icon} /></a> 
                    </div>
                    <div className={styles.social_media_link}>
                        <a href="https://www.instagram.com/ubfnigeria/"><FaInstagram className={styles.social_icon} /></a> 
                    </div>
                    <div className={styles.social_media_link}>
                        <a href="https://www.youtube.com/channel/UCsSy8IDALNDBhRQfQP_31VQ"><FaYoutube className={styles.social_icon} /></a> 
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage